import { useQuery } from '@tanstack/react-query';
import { getChildWorksheets } from '../api/worksheets';

export function useChildWorksheets(learnerId) {
  return useQuery({
    queryKey: ['childWorksheets', learnerId],
    queryFn: () => getChildWorksheets(learnerId),
    enabled: !!learnerId,
    select: (data) => data?.worksheets || data || [],
  });
}
